import { useEffect, useState } from "react";

import { getAccountListing } from "./services/action";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { getAeropayToken } from "../subscription/services/action";

const useMyAccountHelper = () => {
  const dispatch = useAppDispatch();

  const [aeropaySDKToken, setAeropaySDKToken] = useState<string>("");
  const [openAeropaySDK, setOpenAeropaySDK] = useState<boolean>(false);

  const handleOpenAeropaySDK = () => setOpenAeropaySDK(true);
  const handleCloseAeropaySDK = () => setOpenAeropaySDK(false);

  const handleAddAccountBtnClick = () => {
    dispatch(
      getAeropayToken((token: string) => {
        setAeropaySDKToken(token);
      }),
    );
  };

  useEffect(() => {
    dispatch(getAccountListing());
    localStorage.removeItem("account-details");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (aeropaySDKToken) handleOpenAeropaySDK();
  }, [aeropaySDKToken]);

  return {
    openAeropaySDK,
    aeropaySDKToken,

    handleCloseAeropaySDK,
    handleAddAccountBtnClick,
  };
};

export default useMyAccountHelper;
